import React from 'react';

import Breadcrumbs from '@sp/client/components/Breadcrumbs';
import NavBar from '@sp/client/components/NavBar';

import s from './style.less';
import Profile from './profile';
import Password from './password';

const breadcrumbs = [{ name: 'Home', to: '/' }, { name: 'My Details' }];

const CustomerDetails = () => (
  <NavBar withPadding>
    <Breadcrumbs paths={breadcrumbs} />
    <div className={s.header}>Your profile</div>
    <Profile />
    <div className={s.header}>Password</div>
    <Password />
  </NavBar>
);

export default CustomerDetails;
